import { useMemo } from "react";
import getIntervalsInRange from "../../../utils/getIntervalsInRange";
import { useCalendarTime } from "components/Dashboard/DoctorDashboard/views/one-one-sessions/contexts/CalendarTimeContext";
import { useSchedule } from "components/Dashboard/DoctorDashboard/contexts/ScheduleContext";
import moment from "moment-timezone";
import { SINGLE_DAY_DATE_FORMAT } from "../monthly-view.types";
import getMonthlyViewWeeks from "../utils/get-monthly-view-weeks";

const useScheduleIntervalsByDay = () => {
  const { timeRange, currentCalendarTimezone } = useCalendarTime();
  const { schedule } = useSchedule();

  const { weeksInMonth } = getMonthlyViewWeeks(
    timeRange,
    currentCalendarTimezone,
  );

  const scheduleIntervalsByDay = useMemo(() => {
    const calendarStartValue = +timeRange[0];
    const calendarEndValue = +timeRange[1];

    const scheduleIntervalsInRange = schedule.reduce(
      (prev, curr) => [
        ...prev,
        ...getIntervalsInRange(
          curr,
          calendarStartValue,
          calendarEndValue,
          currentCalendarTimezone,
        ),
      ],
      [] as ScheduleInterval[],
    );

    const dates = weeksInMonth.flatMap((week) =>
      week.map((day) =>
        moment
          .tz(day.startISO, currentCalendarTimezone)
          .format(SINGLE_DAY_DATE_FORMAT),
      ),
    );

    const scheduleIntervalsByDay: { [key: string]: boolean } = dates.reduce(
      (prev, curr) => {
        prev[curr] = false;
        return prev;
      },
      {},
    );

    scheduleIntervalsInRange.forEach((interval) => {
      const intervalStartDay = moment(interval.start_time)
        .tz(currentCalendarTimezone)
        .format(SINGLE_DAY_DATE_FORMAT);

      if (intervalStartDay in scheduleIntervalsByDay) {
        scheduleIntervalsByDay[intervalStartDay] = true;
      }
    });
    return scheduleIntervalsByDay;
  }, [timeRange, schedule, currentCalendarTimezone, weeksInMonth]);

  return scheduleIntervalsByDay;
};

export default useScheduleIntervalsByDay;
